const IncomeEntityIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_852_10342)">
      <path
        d="M15.25 5C15.25 6.02881 14.5807 7.07369 13.2594 7.89954C11.9486 8.71878 10.0911 9.25 8 9.25C5.90894 9.25 4.05143 8.71878 2.74065 7.89954C1.41929 7.07369 0.75 6.02881 0.75 5C0.75 3.97119 1.41929 2.92631 2.74065 2.10046C4.05143 1.28122 5.90894 0.75 8 0.75C10.0911 0.75 11.9486 1.28122 13.2594 2.10046C14.5807 2.92631 15.25 3.97119 15.25 5Z"
        stroke="black"
        stroke-width="1.5"
      />
      <path d="M8 16L5 11L11 11L8 16Z" fill="black" />
      <path d="M8 9C8 13.2019 8 11.0455 8 14" stroke="black" stroke-width="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_852_10342">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default IncomeEntityIcon;
